

import { Component } from '@angular/core';




@Component({

    selector: 'payment-cmp',
    templateUrl: './payment.component.html',
   
   
  })
export class PaymentComponent {
  
}


// WEBPACK FOOTER //
// ./src/app/crm/kcc/payment/payment.component.ts